import 'Styles/templates/index.scss';

import LazyVideo from '../components/lazy-video';

LazyVideo();
